<template>
  <div class="layouts widget" style="position: relative">
    <div class="accordion" role="tablist">
      <div
        class="widget-header mx-auto cursor-pointer rrr"
        v-show="isToolbarsCollapsed"
        @click.prevent="updateToolbarsStatus"
        @mouseover="increaseWidth"
        @mouseleave="resetWidth"
      >
        <img
          :src="require('@/assets/svg/views.svg')"
          alt="Views"
          :style="{ width: hoverWidth, marginInline: 'auto' }"
          v-b-tooltip.hover.right.viewport="`${$t('grid.widgets.views.title')}`"
        />
      </div>
      <div
        class="widget-header"
        v-show="!isToolbarsCollapsed">
        <div
          class="icon-title"
          v-if="!searchBarEnabled"
          v-b-toggle="collapsible ? `main-accordion-${id}` : ''">
          <img
            :src="require('@/assets/svg/views.svg')"
            alt="Views"
            :style="{ width: '16px', marginInline: '16px' }"
          />
          <p class="text-center">{{ title }}</p>
        </div>
        <div class="search-collapse" :class="[{ barEnable: searchBarEnabled }]">
          <i
            class="feather icon-plus-circle cursor-pointer fs-5"
            @click="showModal = true"
          ></i>
          <img
            :src="require('@/assets/svg/search.svg')"
            alt="Search"
            :style="{ width: '18px', marginInline: '0.65rem' }"
            v-b-tooltip.hover.bottom.viewport="`${$t('search')}`"
            @click.stop="toggleSearchBar(true)"
            v-if="!searchBarEnabled"
          />
          <search-bar-widgets
            :search-bar-width="searchBarWidth"
            :sidebar-min-width-reached="sidebarMinWidthReached"
            @input="onSearch"
            @toggle-search-bar="toggleSearchBar"
            @reset-search-bar="resetSearchBar"
            v-if="searchBarEnabled"
            ref="viewsSearchBar"
          />
        </div>
        <div>
          <template v-if="collapsible">
            <feather-icon
              v-if="!isConfigModeOn"
              :icon="isCollapseOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="24"
              v-b-toggle="collapsible ? `main-accordion-${id}` : ''"
            />
          </template>
          <span class="handle cursor-move" v-if="isConfigModeOn">
            <feather-icon icon="MenuIcon" size="18" />
          </span>
        </div>
      </div>
      <b-collapse
        :id="`main-accordion-${id}`"
        :accordion="`main-accordion-${id}`"
        role="tabpanel"
        v-model="isCollapseOpen"
        @input="onUpdateStatus"
        v-show="isCollapseOpen && !isToolbarsCollapsed"
      >
        <div
          :class="[
            'layouts-container d-flex flex-wrap justify-content-between',
            { 'flex-column': sidebarMinWidthReached },
          ]"
          v-if="userViews.length"
        >
          <div
            v-for="(view, index) in userViews"
            :key="index"
            :class="[
              'layout',
              {
                selected: checkSelectedView(view.data.id),
                'w-100': sidebarMinWidthReached,
                'w-50': !sidebarMinWidthReached,
              },
            ]"
          >
            <layout-views
              :key="view.updated_at"
              :view="view"
              @edit-view="updateView"
              @set-view="setView"
              @remove-view="onRemoveView"
              @view-history="viewHistory"
            />
          </div>
        </div>
        <div v-else>
          <p class="mb-0 py-1 lead text-center">{{ $t("no_record_found") }}</p>
        </div>
        <PaginationWidgets
          :sidebar-min-width-reached="sidebarMinWidthReached"
          :per-page.sync="perPage"
          :current-page.sync="currentPage"
          :total-records="totalRecords"
          @update:currentPage="updateCurrentPage"
          @update:perPage="updatePerPage"
        />
      </b-collapse>
    </div>
    <views-modal
      :current-preview-selected="currentPreviewSelected"
      :item="item"
      :show-modal="showModal"
      @clean-item="cleanItem()"
      @refresh="getViews()"
      @update:isActive="showModal = false"
    />
    <views-history-modal
      :item="item"
      :show-modal-history="showModalHistory"
      @update:isActive="showModalHistory = false"
    />
  </div>
</template>

<script>
import { BCollapse, VBToggle } from "bootstrap-vue";
import store from "@/store";
import LayoutViews from "../LayoutViews";
import Swal from "sweetalert2";
import PaginationWidgets from "../components/PaginationWidgets.vue";
import SearchBarWidgets from "../components/SearchBarWidgets.vue";
import ViewsModal from "./ViewsModal.vue";
import ViewsHistoryModal from "./ViewsHistoryModal.vue";

export default {
  components: {
    BCollapse,
  },
  components: {
    LayoutViews,
    BCollapse,
    PaginationWidgets,
    SearchBarWidgets,
    ViewsModal,
    ViewsHistoryModal
  },
  directives: {
    "b-toggle": VBToggle,
  },
  props: {
    id: {
      type: Number | String,
      default: 1,
    },
    location: {
      type: String,
      default: "sideBar",
    },
    title: {
      type: String | Number,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: String | Number,
      default: "sidebar",
    },
    selectedLayout: {
      type: String | Number,
      default: null,
    },
    ignoreCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const layouts = [];

    return {
      layouts,
      isCollapseOpen: false,
      loading: true,
      hoverWidth: "16px",
      perPage: 4,
      currentPage: 1,
      search: "",
      searchBarEnabled: false,
      searchBarWidth: 0,
      showModal: false,
      item:{
        id: null,
        name: null,
        data: null,
        is_public: false,
        id_user: null,
        tabId: null,
        data: {
          gridItems: [],
          id: null,
          layout: null,
          order: 1,
          slots: [],
          type: 'view'
        },
        is_camera_view: true,
        coordinates: null,
        validations: [],
        last_status: null
      },
      currentPreviewSelected: null,
      showModalHistory: false
    };
  },
  async mounted() {
    this.isCollapseOpen = this.isOpen;
    this.searchBarWidth = this.$el.offsetWidth - 20;
  },
  watch: {
    userLayouts() {
      this.getViews()
    },
    sidebarWidth() {
      this.searchBarWidth = this.$el.offsetWidth - 20;
    },
  },
  computed: {
    sidebarWidth() {
      return store.state.grid.sidebarWidth;
    },
    activeTabId() {
      return store.state.grid.activeTab;
    },
    tabs() {
      return store.state.grid.tabs;
    },
    tabsQty() {
      return Object.keys(this.tabs).length;
    },
    isConfigModeOn() {
      return store.state.psimConfig.configModeStatus;
    },
    userLayouts() {
      return store.getters["layouts/getUserLayouts"];
    },
    userViews() {
      return store.getters["grid/getUserViews"];
    },
    totalRecords() {
      return store.getters["grid/getTotalRecordsOfViews"];
    },
    sidebarMinWidthReached() {
      return store.getters["grid/sidebarMinWidthReached"];
    },
    isToolbarsCollapsed() {
      if (this.ignoreCollapse) return false;
      return store.state.psimConfig.isToolbarsCollapsed;
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    onSearch(search) {
      this.search = search;
      if (!search) return;
      setTimeout(() => {
        this.getViews();
      }, 100);
    },
    resetSearchBar() {
      this.search = "";
      this.currentPage = 1;
      this.getViews();
    },
    toggleSearchBar(forceValue) {
      if (forceValue === true) {
        this.openSearchBar();
        return;
      }
      if (forceValue === false) {
        this.closeSearchBar();
        return;
      }

      if (this.searchBarEnabled) {
        this.closeSearchBar();
      } else {
        this.openSearchBar();
      }
    },
    openSearchBar() {
      if (this.searchBarEnabled) return;
      this.searchBarEnabled = true;
      this.isCollapseOpen = true;
      this.$nextTick(() => {
        if (this.$refs.viewsSearchBar?.focusInput) {
          this.$refs.viewsSearchBar.focusInput();
        }
      });
    },
    closeSearchBar() {
      if (!this.searchBarEnabled) return;
      this.searchBarEnabled = false;
      this.resetSearchBar();
    },
    updateCurrentPage(page) {
      this.currentPage = page
      this.getViews()
    },
    updatePerPage(perPage) {
      this.perPage = perPage
      this.getViews()
    },
    getViews() {
      const params = {
        search: this.search,
        max: this.perPage,
        currentPage: this.currentPage
      }
      if(this.search && this.search.length < 3) return
      store.dispatch("grid/getUserViews", params);
    },
    onUpdateStatus(value) {
      this.$emit("widget-collapsed", {
        id: this.id,
        property: "isOpen",
        location: this.location,
        value,
      });
    },
    onRemoveView(id) {
      Swal.fire({
        title: this.$t("messages.delete.title"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("actions.delete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          store.dispatch("grid/removeView", { id }).then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: this.$t("messages.delete.deleted_correctly"),
                icon: "CheckIcon",
                variant: "success",
              },
            });
          });
        }
      });
    },
    checkSelectedView(idView) {
      return this.activeTabId == idView;
    },
    setView(view) {
      const viewData = view.data;
      if (!Object.keys(this.tabs).includes(viewData.id)) {
        store.dispatch("grid/addNewTab", { viewData });
      }
      store.dispatch("grid/setActiveTab", viewData.id);
    },
    updateToolbarsStatus() {
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED",
        !store.state.psimConfig.isToolbarsCollapsed
      );

      this.isCollapseOpen = true;
    },
    increaseWidth() {
      this.hoverWidth = "22px";
    },
    resetWidth() {
      this.hoverWidth = "16px";
    },
    cleanItem() {
      this.item = {
        id: null,
        name: null,
        data: null,
        id_user: null,
        is_public: false,
        tabId: null,
        data: {
          gridItems: [],
          id: null,
          layout: null,
          order: 1,
          slots: [],
          type: 'view'
        },
        validations: [],
        last_status: null,
        coordinates: null
      }
    },
    updateView(view) {
      this.item = {
         ...view
      };

      this.showModal = true;
    }
    ,
    viewHistory(view) {
      this.item = {
         ...view
      }

      this.showModalHistory = true;
    }
  },
};
</script>
